module.exports = __webpack_public_path__ + "img/hours.9c934454.svg";